import React, { useEffect, useMemo } from "react";
import { getUsersExtraActivities } from "../../../redux/api/reports.api";
import { fetchUsers } from "../../../redux/api/admin.api";

import { useAppDispatch, useAppSelector } from "../../../redux/hooks";

import TableWidget from "../../../components/tables/TableWidget";
import { TableActions } from "../../../components/tables/tableContext/TableContext";

import ExtraActivitiesDropdownsHeader from "./components/ExtraActivitiesDropdownsHeader";

import {
  generateUsersExtraActivitiesHeader,
  generateUsersExtraActivitiesTableData,
} from "./tableConfigs/generateUsersExtraActivitiesTable";

function ExtraActivities() {
  const dispatch = useAppDispatch();

  const {
    reports: {
      usersExtraActivities: {
        data: { data: usersExtraActivities, total },
        isLoading,
      },
    },
  } = useAppSelector((state) => ({
    reports: state.reports,
  }));

  useEffect(() => {
    dispatch(
      fetchUsers({
        page: 1,
        perPage: 10000,
      }),
    );
  }, [dispatch]);

  const handleTableActions = (action: TableActions) => {
    if (
      action.tablePagination.page &&
      action.tablePagination.rowsPerPage &&
      action.tableSearch
    ) {
      if (
        action.tableSearch.selectedMonth &&
        action.tableSearch.selectedYear &&
        action.tableSearch.selectedUsers
      ) {
        dispatch(
          getUsersExtraActivities({
            page: action.tablePagination.page,
            per_page: action.tablePagination.rowsPerPage,
            selectedUsers: JSON.parse(action.tableSearch.selectedUsers),
            month: action.tableSearch.selectedMonth,
            year: action.tableSearch.selectedYear,
          }),
        );
      }
    }
  };

  const tableHeader = useMemo(
    () => generateUsersExtraActivitiesHeader(usersExtraActivities),
    [usersExtraActivities],
  );

  const tableItems = useMemo(
    () => generateUsersExtraActivitiesTableData(usersExtraActivities),
    [usersExtraActivities],
  );

  return (
    <TableWidget
      tableTitle="Extra activitati utilizatori"
      tableHeaderData={tableHeader}
      tableItemsData={tableItems}
      handleTableActions={handleTableActions}
      CustomHeaderComponent={ExtraActivitiesDropdownsHeader}
      totalItems={total}
      tableLoading={isLoading}
      withGlobalSearch={false}
      withGlobalFilter={false}
    />
  );
}

export default ExtraActivities;
